import TooltipEx from "@components/Tooltip";
import React from "react";
import classNames from "classnames";
import styles from "src/pages/presenze/monitorWF/filtroRichiesteWF.module.css"
import {UseFormGetValues, UseFormSetValue} from "react-hook-form";
import {MonitorWfForm} from "./monitorWF";
import {IconAsterisk, IconBan, IconCheck, IconHourglass, IconScale} from "@tabler/icons-react";

interface FiltroStatiProps {
    setValue: UseFormSetValue<MonitorWfForm>,
    getValues: UseFormGetValues<MonitorWfForm>
    statiClassName: string,
}

export const FiltroStati: React.FC<FiltroStatiProps> = ({setValue, getValues, statiClassName}) => {

    let selectAll = getValues('stati.selectAll');
    let in_attesa = getValues('stati.IN_ATTESA');
    let in_valutazione = getValues('stati.IN_VALUTAZIONE');
    let accettata = getValues('stati.ACCETTATA');
    let rifiutata = getValues('stati.RIFIUTATA');

    return <div className="inline-flex items-center">Stati:&nbsp;
        <div className={`${styles.statiFilter} ${statiClassName}`}>

            <a key="selectAll" className={classNames(styles.stateContainer, styles.hoverClass, selectAll ? styles.selectedClass : '')}
               onClick={() => {
                   setValue('stati.selectAll', true)
                   setValue('stati.IN_ATTESA', false)
                   setValue('stati.IN_VALUTAZIONE', false)
                   setValue('stati.ACCETTATA', false)
                   setValue('stati.RIFIUTATA', false)
               }}>
                <IconAsterisk size={14}/>
            </a>
            <TooltipEx tooltip={`In attesa di valutazione`}>
                <button key="IN_ATTESA" type="button"
                        className={classNames(styles.stateContainer, styles.hoverClass, in_attesa ? styles.selectedClass : '')}
                        onClick={() => {
                            setValue('stati.IN_ATTESA', !in_attesa)
                            setValue('stati.selectAll', false)
                        }}>
                    <IconHourglass size={16}/>
                </button>
            </TooltipEx>
            <TooltipEx tooltip={`In valutazione`}>
                <button key="IN_VALUTAZIONE" type="button"
                        className={classNames(styles.stateContainer, styles.hoverClass, in_valutazione ? styles.selectedClass : '')}
                        onClick={() => {
                            setValue('stati.IN_VALUTAZIONE', !in_valutazione)
                            setValue('stati.selectAll', false)
                        }}>
                    <IconScale size={16}/>
                </button>
            </TooltipEx>
            <TooltipEx tooltip={`Accettate`}>
                <button key="ACCETTATA" type="button"
                        className={classNames(styles.stateContainer, styles.hoverClass, accettata ? styles.selectedClass : '')}
                        onClick={() => {
                            setValue('stati.ACCETTATA', !accettata)
                            setValue('stati.selectAll', false)
                        }}>
                    <IconCheck className="h-4 w-4"/>
                </button>
            </TooltipEx>
            <TooltipEx tooltip={`Respinte`}>
                <button key="RIFIUTATA" type="button"
                        className={classNames(styles.stateContainer, styles.hoverClass, rifiutata ? styles.selectedClass : '')}
                        onClick={() => {
                            setValue('stati.RIFIUTATA', !rifiutata)
                            setValue('stati.selectAll', false)
                        }}>
                    <IconBan size={16}/>
                </button>
            </TooltipEx>
        </div>
    </div>
};
